import { BaseUserQueue } from '../base-user-queue';
import { ToastService } from '@hss-m/uikit-common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StylistsService } from '../../stylists.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppService } from 'src/app/shared/services/app.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ViewTablePage } from 'src/app/shared/modules/data-view-table/view-table.service';
import { getContextMenuConfig, getDataTableColumnConfigForTodaysMessage, getTodaysMessagesFilters } from '../config.const';
import { DataViewTableConfig, ViewTableComponent } from 'src/app/shared/modules/data-view-table/view-table/view-table.component';

@Component({
  selector: 'app-todays-messages',
  templateUrl: '../all-users-queues/all-users-queues.component.html',
  styleUrls: ['../all-users-queues/all-users-queues.component.scss']
})
export class TodaysMessagesComponent extends BaseUserQueue implements OnInit {
 
  @ViewChild(ViewTableComponent) viewTableComponent: ViewTableComponent;

  config: DataViewTableConfig = {
    dataKey: 'queues',
    page: new ViewTablePage(),
    columns: getDataTableColumnConfigForTodaysMessage(this),
    selection: true,
    noContentMessage: 'Apply any filter or sort on table to load the products.',
    filtersValueRetain: true,
    onDataLoad: () => {
      this.config.noContentMessage = 'No Queues found';
    },
    contextMenuConfig: {
      ...getContextMenuConfig(this),
      gridHeaderLabel: 'Today\'s Queues'
    },
    tableId: 'qatch.columns./stylists/all-queues/todays'
  };
  filterId = 'todays-queues';
  showBreadcrumb = true;
  breadcrumbItems = [{'label': 'Queues'}, {'label': 'Today\'s Queues'}]

  constructor(
    protected override deviceService: DeviceDetectorService,
    protected override readonly stylistsService: StylistsService,
    protected route: ActivatedRoute,
    protected override router: Router,
    protected override authService: AuthService,
    private appService: AppService,
    protected override toastService: ToastService,
    protected override modalService: NgbModal
  ) {
    super(stylistsService, router, deviceService, authService, toastService, modalService);
    this.filters = getTodaysMessagesFilters(this);
    this.route.params.subscribe(params => {
      this.config.page.pageNumber = 0;
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override postFirebaseAuth() {
    // super.onInit();
    this.filterRolesLoaded = true;
      setTimeout(() => {
       this.config.url ='stylist/users/all-queues/todays';
    }, 3000);
  }

  productsKey(row: any) {
    const item = `${row.product_id} - ${row.product_name}`;
    return item;
  }

  usersKey(row: any) {
    const item = `${row.uid} - ${row.first_name} ${row.last_name || ''}`;
    return item;
  }

  getViewTableComponent(): ViewTableComponent {
    return this.viewTableComponent;
  }

  getNameOfSelectedUser(){
    return '';
  }

}
